/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import * as _ from 'underscore';
import Utilities from 'app/utility/Utilities.js';
import UserMessages from 'app/modules/UserMessageModule.js';

function removeErrors(errors, keys) {
    let nextErrors = [];

    if (!_.isArray(keys)) {
        keys = [keys];
    }

    for (let i = 0; i < errors.length; ++i) {
        let keyFound = false;
        for (let j = 0; j < keys.length; ++j) {
            if (errors[i].type.match(keys[j])) {
                keyFound = true;
            }
        }
        if (!keyFound) {
            nextErrors.push(errors[i]);
        }
    }

    return nextErrors;

}

function addMessage(list, action) {
    let insert = true;

    // de-dupe on the way in
    for (let i = 0; i < list.length; ++i) {
        if (action.type === list[i].type &&
            action.message === list[i].message &&
            action.messageType === list[i].messageType) {
            insert = false;
            break;
        }
    }
    if (insert) {
        list.push(action);
    }

    return list;

}

export const app = (state = defaultState.app, action) => {
    let nextState = Utilities.deepClone(state);

    // prior errors for an action should always be cleared when the action
    // is attempted again
    if (action.status === constants.STATE_TXRX) {
        nextState.errors.api = removeErrors(nextState.errors.api, action.type);
    }

    // any api action toggles it's associated loading flag for use
    // in components to know when an api call completes.
    // Errors automatically reset the loading flag to false
    if (nextState.loading[action.type] !== undefined) {
        if (action.status === constants.STATE_TXRX) {
            nextState.loading[action.type] = true;
        } else {
            nextState.loading[action.type] = false;
            if (action.type === constants.API_ERROR) {
                if (action.payload !== undefined && action.payload.type !== undefined) {
                    nextState.loading[action.payload.type] = false;
                }
            }
        }
    }

    // the first _GET action toggles the first load flag
    // from false to true
    if (nextState.firstLoad[action.type] !== undefined) {
        if (action.status === constants.STATE_SUCCESS && nextState.firstLoad[action.type] === false) {
            nextState.firstLoad[action.type] = true;
        }
    }

    if (nextState.hasNoData[action.type] !== undefined) {
        if (action.status === constants.STATE_SUCCESS) {
            if (action.payload !== undefined && action.payload !== null) {
                if ((_.isArray(action.payload.length) && action.payload.length === 0) || Object.keys(action.payload).length === 0) {
                    nextState.hasNoData[action.type] = true;
                }
            }
        }
    }

    switch (action.type) {
        case constants.APP_READY:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.configLoaded = true;
                nextState.config = action.payload;
                // Load the constants into global scope. Not my favorite thing to do,
                // but some reducers need access to constant values shared between API and UI
                // and this seems to be an easy way to accomplish that
                window.DlvrConstants = action.payload.constants;
                // need to explicitly set APP_LOADING to false because
                // the bootstrap stars with APP_LOADING and ends in APP_READY
                // something to smooth out later
                nextState.loading.APP_LOADING = false;
            }
            break;

        case constants.APP_LOGIN_USER:
        case constants.APP_CREATE_USER:
        case constants.APP_AUTOLOGIN:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.userSessionActive = true;
                if (action.payload) {
                    if (action.payload.location) {
                        nextState.statuses.login.nextLocation = action.payload.location;
                    }
                    if (action.payload.statusCode) {
                        nextState.statuses.login.statusCode = action.payload.statusCode;
                    }
                    if (action.payload.statusMsg) {
                        nextState.statuses.login.statusMsg = action.payload.statusMsg;
                    }
                }
            }
            break;


        case constants.APP_CHECK_USER:
            if (action.status === constants.STATE_SUCCESS) {
                if (action.payload.success === 1) {
                    nextState.userSessionActive = true;
                }
            }
            break;

        case constants.USER_FETCH:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.userLoaded = true;
                nextState.flags.routeViewType = parseInt(action.payload.routeViewType);
            }
            break;

        case constants.USER_FETCH_PERMS:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.userPermsLoaded = true;
            }
            break;

        case constants.NOTIFICATIONS_LIST:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.statuses.socialsDisconnected = _.where(action.payload, {type: 10, entityType: 'output'});
            }
            break;

        case constants.CURATION_ROUTE_CREATE:
        case constants.CURATION_INPUT_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.messages = addMessage(nextState.messages, UserMessages.generateFlashMessage(UserMessages.input.created, constants.CURATION_INPUT_CREATE));
            }
            break;

        case constants.SOCIAL_CHECK_AUTH:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.messages = addMessage(nextState.messages, UserMessages.generateMessage(UserMessages.social.test, constants.SOCIAL_CHECK_AUTH))
            }
            break;

        case constants.SHORTENER_TEST:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.messages = addMessage(nextState.messages, UserMessages.generateMessage(UserMessages.shortener.test, constants.SHORTENER_TEST));
            }
            break;

        case constants.SHORTENER_UPDATE:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.messages = addMessage(nextState.messages, UserMessages.generateMessage(UserMessages.shortener.updated, constants.SHORTENER_UPDATE));
            }
            break;



        case constants.API_ERROR:
            if (action.payload.type === constants.APP_SET_USER_SESSION) {
                nextState.userSessionActive = false;
                break;
            }
            if (action.payload.error !== undefined && action.payload.error.isNetworkError !== undefined) {
                if (action.payload.type === constants.UTILITIES_URL_INFO_FETCH) {
                    nextState.messages = addMessage(state.messages, UserMessages.generateFlashMessage(UserMessages.app.networkErrorUrl, 'NETWORK_ERROR'));
                } else {
                    nextState.messages = addMessage(state.messages, UserMessages.generateFlashMessage(UserMessages.app.networkError, 'NETWORK_ERROR'));
                }
            }
            nextState.errors.api.push(action.payload);
            break;

        case constants.API_ERROR_DELETE:
            // index == null shorthand for delete all
            if (action.index === null) {
                nextState.errors.api = [];
            } else {
                nextState.errors.api = removeErrors(nextState.errors.api, action.keys);
            }
            break;

        case constants.APP_ERROR_SET:
            nextState.errors.local.push(action.error);
            break;

        case constants.APP_ERROR_DELETE:
            if (action.index === null) {
                nextState.errors.local = [];
            } else {
                nextState.errors.local = removeErrors(nextState.errors.local, action.keys);
            }
            break;

        case constants.APP_MESSAGES_CREATE:
            action.message.id = new Date().getTime();
            nextState.messages = addMessage(nextState.messages, action.message);
            break;

        case constants.APP_MESSAGES_DELETE:
            let messages = nextState.messages,
                nextMessages = [];
            if (messages) {
                if (action.id !== undefined) {
                    for (let i = 0; i < messages.length; ++i) {
                        if (parseInt(messages[i].id, 10) !== parseInt(action.id, 10)) {
                            nextMessages.push(messages[i]);
                        }
                    }
                    nextState.messages = nextMessages;

                } else if (action.types === null) {
                    nextState.messages = nextMessages;

                } else {
                    let keys = (_.isArray(action.types)) ? action.types : [action.types];

                    for (let i = 0; i < messages.length; ++i) {
                        let keyFound = false;
                        for (let j = 0; j < keys.length; ++j) {
                            if (messages[i].type.match(keys[j]) || messages[i].messageType.match(keys[j])) {
                                keyFound = true;
                            }
                        }
                        if (!keyFound) {
                            nextMessages.push(messages[i]);
                        }
                    }
                    nextState.messages = nextMessages;

                }
            }
            break;

        default:
            break;
    }

    return nextState;

};
